import './index.scss';
// Inicializa plugins y locale de dayjs antes de montar cualquier DatePicker.
import './dayjs.config';
import './i18n';

import { Spin } from 'antd';
import React from 'react';
import { createRoot } from 'react-dom/client';
import vhCheck from 'vh-check';

import App from './App';
import ServiceWorkerWrapper from './components/general/ServiceWorkerWrapper';
import { APP_BASENAME } from './constants/urls';
import { initSentry } from './sentry.config';

vhCheck();
// Inicializa Sentry al inicio para capturar errores de bootstrap y navegacion.
initSentry();

const container = document.getElementById('root')!;
const root = createRoot(container);
const { pathname, search, hash } = window.location;
const isOnBasePath = pathname === APP_BASENAME || pathname.startsWith(`${APP_BASENAME}/`);

if (!isOnBasePath) {
  const normalizedPath = pathname === '/' ? '' : pathname;

  window.location.replace(`${APP_BASENAME}${normalizedPath}${search}${hash}`);
} else {
  root.render(
    <>
      <React.Suspense
        fallback={
          <div
            style={{
              height: '100dvh',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
            <Spin size="large" />
          </div>
        }>
        <ServiceWorkerWrapper />
        <App />
      </React.Suspense>
    </>,
  );
}
